import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=d2dee00c&"
import script from "./content2.vue?vue&type=script&lang=js&"
export * from "./content2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports